import { Observable, of, from } from 'rxjs';
import { catchError, switchMap, map, mergeMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import RegisterService from '../services/register.service';

import { RegisterAction, RegisterActions, RegisterRequest, RegisterSuccess, RegisterError } from '../actions';
import {CreateSuccessNotice} from "../../store/actions/toaster.action";

const registerEpic = (action$: Observable<RegisterAction>) => action$.pipe(
  ofType<RegisterRequest>(RegisterActions.RegisterRequest),
  switchMap((action) => from(RegisterService.register(action.apiOptions)).pipe(
    map(() =>
      new RegisterSuccess({
        registered: true,
        errorText: '',
      }),
    ),
    catchError((error) => (
      of(
        new RegisterError({
          registered: false,
          errorText: error.message || 'Sorry, we were unable to create your organization, please complete all fields.',
        })
      )
    ))
  )),
);

const registerSuccessEpic = (action$: Observable<RegisterAction>) => action$.pipe(
  ofType<RegisterSuccess>(RegisterActions.RegisterSuccess),
  mergeMap(() => of(
    new CreateSuccessNotice('Success', 'You will receive an email with next steps')
  ))
);

export default [
  registerEpic,
  registerSuccessEpic,
];
